import {
  GET_SITE_CSV,
  GET_TKC_CSV,
  GET_ATTENDANCE_CSV,
  GET_ATTENDANCE_CSV_SUMMARY,
  GET_COST_CSV
} from "@/store/modules/mutation-types";

export default {
  actions: {
    async [GET_SITE_CSV]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/csv_downloads/site",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_TKC_CSV]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/csv_downloads/tkc",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_ATTENDANCE_CSV]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/csv_downloads/attendance",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_ATTENDANCE_CSV_SUMMARY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/csv_downloads/attendance_summary",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_COST_CSV]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/csv_downloads/cost",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  }
};
